// extracted by mini-css-extract-plugin
export var label = "_jp-2";
export var slideContainer = "_jp-0";
export var slider = "_jp-1";